<template>
    <div>
        <!--盘点报表-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="单品数:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.totalGoodsItemNums}}</strong>
                        </FormItem>
                        <FormItem  label="商品数:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.totalGoodsNums}}</strong>
                        </FormItem>
                        <FormItem  label="盈亏数量:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.profitAndLossNum}}</strong>
                        </FormItem>
                        <FormItem  label="盈亏金额:" style="margin-right: 30px">
                            <strong class="result">￥{{dataTotl.profitAndLossMoney}}</strong>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="first">
                 <span v-if="row.type=='盘亏'" style="color: #4aca58">{{row.type}}</span>
                <span v-else style="color: #ff5e5e">{{row.type}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" @click="$router.push({path:'/invenDetail',query:{id:row.id}})">详情</Button>
            </template>
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
import { exportExcel } from '@/common/exportExcel';
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '盈亏', key: 'type',align:'center',slot: 'first',},
                    {title: '订单号', key: 'code' ,align:'center' },
                    {title: '盘点人', key: 'adminName',align:'center'  },
                    {title: '盘点数量', key: 'quantity' ,align:'center' },
                    {title: '盘点时间', key: 'time' ,align:'center' },
                    {title: '盈亏数量', key: 'isNumber' ,align:'center' },
                    {title: '操作', key: 'edit' ,align:'center',slot: 'action',},
                ],
                data: [],
                dataTotl:{},
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                loadingTable:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(-7)
            this.valuedate[1] = this.nowTime
            this.getSetpointList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
        },

        methods: {
            exportExcel() {
                const params = {
                    cid: this.cid,
                    sid: this.sid,
                    time: this.valuedate[0],
                    endtime:this.valuedate[1],         
            };
            exportExcel(this.$Api.exportInventoryList, params, this.$Message, new Date().toLocaleString() + '盘点报表');
        },
            //获取盘点列表
            getSetpointList(startTime,endTime,page,rows){
                this.$Api.getSetpointList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.page.total = res.count
                        res.data.forEach((item,index)=>{
                             var PurchaseList={}
                            var nm=0
                            var um=0
                             item.sGoods.forEach((m,n)=>{
                                 m.sItems.forEach((k,v)=>{
                                     nm=nm+k.nownum
                                     um=um+k.checknum
                                     if(um-nm>=0){
                                         PurchaseList.type = "盘盈"
                                     }else {
                                         PurchaseList.type = "盘亏"
                                     }
                                     PurchaseList.isNumber = k.quantity
                                 })
                             })
                             PurchaseList.id = item.id,
                             PurchaseList.code= item.code,
                             PurchaseList.adminName= item.adminName,
                             PurchaseList.quantity=item.quantity,
                             PurchaseList.time=item.time
                             this.data.push(PurchaseList)

                        })
                        this.loadingTable=false
                         this.getSetpointData(startTime,endTime)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            getSetpointData(startTime,endTime){
                this.$Api.getSetpointData({
                    cid: this.cid,
                    sid: this.sid,
                    time: startTime,
                    endtime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.dataTotl = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getSetpointList(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows)
            },
            onGongPageTotal(num){
                this.getSetpointList(this.valuedate[0],this.valuedate[1],num,this.page.rows)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
</style>